const styles = theme => ({
  container: {
    '& $accordionFrame:not(:last-child)': {
      borderBottom: `1px solid ${theme.palette.primary.borderColor} !important`,
    },
  },

  accordionFrame: {
    boxShadow: 'none !important',
    padding: '16px 0',
    margin: '0 !important',
  },

  accordionSummary: {
    alignItems: 'flex-start',
    padding: '0 16px',
    minHeight: 'auto !important',
    '& .MuiAccordionSummary-content': {
      width: '100%',
      margin: '0 !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '& p': {
        color: theme.palette.primary.foreground,
        fontSize: '18px',
        fontWeight: '500',
      },
    },
  },

  accordionDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '24px 24px 8px 50px',
  },

  mainServiceContainer: {
    border: '0 !important',
  },

  checkboxHolderFlex: {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
    padding: '24px 0 0 30px',
  },

  permissionCheckBoxHolder: {
    '& .MuiIconButton-label svg': {
      width: '20px !important',
    },
  },
});

export default styles;
